import React from "react";
import { Trans, useTranslation } from "react-i18next";

import Styles from "../SleepingCustomer.module.scss";

type Props = {
  categoryName: string,
  address: {
    postalcode: string,
    location: string,
    street: string,
    streetNumber: string,
  },
  counterNumber?: string,
  subheading?: boolean,
};

const Heading = ({
  categoryName,
  address: { postalcode, location, street, streetNumber },
  counterNumber,
  subheading = true,
}: Props) => {
  const { t } = useTranslation(["sleepingCustomer"]);
  const longLocation = location.includes("/");

  return (
    <div className={Styles.headingWrapper}>
      <div className={Styles.heading}>{t("heading", { categoryName })}</div>
      {longLocation ? (
        <div>
          <div className={Styles.address}>{`${street} ${streetNumber}, ${postalcode}`}</div>
          <div className={Styles.address}>{location}</div>
        </div>
      ) : (
        <div className={Styles.address}>{`${street} ${streetNumber}, ${postalcode} ${location}`}</div>
      )}
      {counterNumber && <div className={Styles.subheading}>{t("subheading", { counterNumber })}</div>}
      {subheading && (
        <div className={`${Styles.subheadingGreen} theme-color-primary`}>
          <Trans i18nKey={"sleepingCustomer:subheadingGreen"}>
            <br />
          </Trans>
        </div>
      )}
    </div>
  );
};

export default Heading;
